import withStyles from "isomorphic-style-loader/lib/withStyles";
import debounce from "lodash.debounce";
import isNil from "lodash.isnil";
import reduce from "lodash.reduce";
import moment from "moment";
import React from "react";
import { withRouter } from "react-router-dom";
import {
  Button,
  ButtonGroup,
  Col,
  Container,
  Modal,
  ModalBody,
  ModalFooter,
  Row
} from "reactstrap";
import BaseInput from "../../../toolkit/baseInput";
import BasicSpinner from "../../../toolkit/basicSpinner";
import accessCodes from "../../../utils/accessCodes";
import {
  FORMA_DE_PAGO,
  ID_CHEQUE,
  ID_CONTADO,
  ID_DOCE_MESES,
  ID_EFECTIVO,
  ID_NUEVE_MESES,
  ID_SEIS_MESES,
  ID_TRANSFERENCIA,
  ID_TRES_MESES,
  LINEA_PAGO,
  OPTIONS_FORMA_PAGO_INTELIPOS,
  ORIGEN_PAGO_TDC,
  POR_DEFINIR_99,
  TARJETA_AMEX,
  TARJETA_CREDITO,
  TARJETA_DEBITO
} from "../../../utils/constants";
import { handleRequestError } from "../../../utils/helpers";
import {
  errorNotification,
  infoNotification
} from "../../../utils/notifications";
import { getMitInteliposDevicesByClubIdRequest } from "../../actions/clubs";
import {
  createInteliposChargeRequest,
  getInteliposChargeResponseByReference
} from "../../actions/intelipos";
import TextWithLineBreaks from "../common/TextWithLineBreaks";
import { itemToProduct } from "../sportsProductsNewQuote";
import ProductsList from "../sportsProductsNewQuote/ProductsList";
import {
  AMEX_BANK_NAME,
  mesesSinInteresesDefault,
  mesesSinInteresesMonths,
  OrigenPlataformaVentaPago,
  Props,
  QUOTE,
  State
} from "./interfaces";
import PaymentsTable from "./PaymentsTable";
import ReimpresionModal from "./ReimpresionModal";
import s from "./styles.scss";

const { PERMISSION_99 } = accessCodes;

const QUOTE_CREATED_STATUS = "CREADA";

const FORMA_PAGO_TOKENIZACION = [TARJETA_CREDITO, TARJETA_DEBITO, TARJETA_AMEX];

const TOKENIZATION_ACTIVATION_PRODUCT_ID = 10005069;

const valueToField = (value): string => {
  return (
    (value === ID_TRES_MESES && "estatusTresMeses") ||
    (value === ID_SEIS_MESES && "estatusSeisMeses") ||
    (value === ID_NUEVE_MESES && "estatusNueveMeses") ||
    (value === ID_DOCE_MESES && "estatusDoceMeses")
  );
};

const getSubTotal = (products): number => {
  return reduce(products, (accum, { total }) => accum + total, 0);
};

const emptyFields = () => ({
  referencia: "",
  numeroAutorizacion: "",
  formaDePago: TARJETA_CREDITO,
  origenPago: ORIGEN_PAGO_TDC,
  mesesSinIntereses: ID_CONTADO,
  bancoId: "",
  monto: "0",
  numeroCheque: "",
  numeroCuenta: "",
  empresaEmisoraId: 0,
  tokenizar: false
});

const getLinkCaja = cajaId => `/productos/caja/${cajaId}`;

const getTokenReference = (): string => moment().format("YYMMDDhhmmss");

//VERSION TPV - COBRO POR PUERTO USB

class SportsProductsQuoteInteliposById extends React.Component<Props, State> {
  state = {
    mesesSinIntereses: "",
    optionsMonthsWithoutInterest: [
      ...mesesSinInteresesDefault,
      ...mesesSinInteresesMonths
    ],
    products: [],
    fields: emptyFields(),
    pagos: [],
    quote: null,
    isPending: false,
    newCart: null,
    freezeObject: {},
    reimpresionModal: false,
    objetoReimpresion: {},
    permission99: [],
    getReference: true,
    referenciaOtorgadaPorTesoreria: false,
    pagoRealizadoPorApp: false,
    readCard: {},
    showModalNoSale: false,
    userMitTerminalCredentials: null,
    tmpMitUser: null,
    tmpMitPassword: null,
    showModalUpdateMitCredentials: false,
    showModalDatosFactValidacion: false,
    acceptedModalDatosFactValidacion: false,
    applyingMainPayment: false,
    applyingCardPayment: false,
    hasFormaPagoForzosa: false,

    inteliposDevices: [],
    waitingPayment: false,
    inteliposPrechargeData: null,
    inteliposChargeResponse: null,
    applyPaymentModalIsOpen: false
  };

  channel = new MessageChannel();
  port1 = null;

  getOptionsMonthsWithoutInterestForPaymentLine() {
    const optionsMonthsWithoutInterest = [
      ...mesesSinInteresesDefault,
      ...mesesSinInteresesMonths
    ];
    optionsMonthsWithoutInterest.forEach(x => (x.active = true));
    return optionsMonthsWithoutInterest;
  }

  updateProducts = async (quote: QUOTE) => {
    const { productos, total, pagos: pagosQuote } = quote;
    const products = productos.map(itemToProduct);
    let pagos = [];
    if (pagosQuote != undefined) {
      pagos = pagosQuote.filter(pagos => pagos.estatus != "RECHAZADO");
    }
    const aPagar = (
      total - reduce(pagos, (acc, { monto }) => acc + monto, 0)
    ).toFixed(2);
    await this.setState({
      products,
      pagos: pagosQuote != undefined ? pagosQuote : [],
      quote,
      fields: {
        ...emptyFields(),
        monto: aPagar < 0 ? 0 : aPagar
      }
    });
  };

  async componentDidUpdate({ cashboxById: prevCashboxById }) {
    const { cashboxById, terminal } = this.props;
    if (
      cashboxById &&
      cashboxById.productos.length != 0 &&
      this.state.getReference &&
      terminal.ReferenceSantander.length == 0 &&
      !!cashboxById.sucursalClubId
    ) {
      this.props.getRefenceSantanderCargo(
        cashboxById.sucursalClubId.toString(),
        cashboxById.productos[0].itemId.toString(),
        "TDC"
      );
      this.props.getReferencesNotUsed(cashboxById.sucursalClubId.toString());
      this.setState({ getReference: false });
    }
    if (cashboxById && prevCashboxById !== cashboxById) {
      await this.updateProducts(cashboxById);

      const hasFormaPagoForzosa = (this.state.products || []).some(
        x => !!x.forzarFormaPago
      );
      if (hasFormaPagoForzosa) {
        const formaDePagoForzosa = (this.state.products || [])
          .filter(x => !!x.forzarFormaPago)
          .map(({ forzarFormaPago }) => forzarFormaPago)[0];
        let fp = null;
        switch (formaDePagoForzosa) {
          case "EFECTIVO":
            fp = ID_EFECTIVO;
            break;
          case "CHEQUE":
            fp = ID_CHEQUE;
            break;
          case "TDC":
            fp = TARJETA_CREDITO;
            break;
          case "TDD":
            fp = TARJETA_DEBITO;
            break;
          case "AMEX":
            fp = TARJETA_AMEX;
            break;
          case "TRANSFERENCIA":
            fp = ID_TRANSFERENCIA;
            break;
          case "POR_DEFINIR_99":
            fp = POR_DEFINIR_99;
            break;
          case "PAGO_EN_LINEA":
            fp = LINEA_PAGO;
            break;
        }

        const { fields } = this.state;
        fields.formaDePago = fp;
        this.setState({
          permission99: [fp],
          fields: { ...fields },
          hasFormaPagoForzosa
        });
      }
    }

    console.info(cashboxById);

    //Si el usuario no inicio sesión en algún club,
    if (
      !!cashboxById &&
      !cashboxById.sucursalClubId &&
      !this.state.showModalNoSale
    ) {
      this.setState({ showModalNoSale: true });
    }

    //Si hay errores de validacion de datos de facturacion
    if (
      !!cashboxById &&
      !!cashboxById.erroresDatosFacturacion &&
      !this.state.showModalDatosFactValidacion &&
      !this.state.acceptedModalDatosFactValidacion
    ) {
      this.setState({ showModalDatosFactValidacion: true });
    }
  }

  componentDidMount() {
    const { productsList } = this.props;

    let formasDePago = [...OPTIONS_FORMA_PAGO_INTELIPOS];

    this.setState({ permission99: [...formasDePago] });

    this.setState({
      fields: {
        ...this.state.fields,
        monto: this.props.productsList.reduce((acc, e) => e.total + acc, 0)
      },
      newCart: !this.props.cartCreated
        ? {
            total: productsList.reduce((acc, e) => e.total + acc, 0),
            montoIva: productsList.reduce((acc, e) => e.montoIva + acc, 0),
            subTotal: productsList.reduce((acc, e) => e.subTotal + acc, 0)
          }
        : null,
      products: productsList
      // dataTerminal: objSave
    });

    //Se inicializa el puerto para comunicación con mit
    this.port1 = this.channel.port1;

    //Se obtienen los dispositivos de intelipos
    this.getClubInteliposDevices();
    this.mitInteliposRetrivingChargeResponseProcessStart();
  }

  componentWillUnmount() {
    this.setState({
      dataTerminal: {},
      referenciaOtorgadaPorTesoreria: false,
      pagoRealizadoPorApp: false,
      readCard: {}
    });
    this.props.clearLogueoRedux();
  }

  getClubInteliposDevices = () => {
    if (!!this.props.userContext) {
      const { userId, clubSessionId } = this.props.userContext;

      getMitInteliposDevicesByClubIdRequest(clubSessionId)
        .then(async ({ data }) => {
          console.info(data);
          if (!!data) {
            await this.setState({
              inteliposDevices: [...data]
            });

            if (data.length > 0) {
              let { fields } = this.state;
              fields.toknumeroSerieInteliposenizar = data[0].numeroSerie;
              this.setState({ fields });
            }
          }
        })
        .catch(handleRequestError);
    }
  };

  onChangeBank = e => {
    e.preventDefault();
    const bancoId = e.target.value;
    const bank = this.props.banksMonthsWithoutInterest.find(
      banco => banco.bancoId == bancoId
    );
    const optionsMonthsWithoutInterest = bank
      ? this.getMonthWithoutInterestOptions(bank)
      : [...mesesSinInteresesDefault, ...mesesSinInteresesMonths];
    this.setState({
      ...this.state,
      mesesSinIntereses: "",
      optionsMonthsWithoutInterest,
      fields: {
        ...this.state.fields,
        bancoId
      }
    });
  };

  setFreezeObject = data => {
    this.setState({ freezeObject: data });
  };

  tieneCargosMembresia = () => {
    return (
      (this.state.products || []).filter(x => x.tipoItem == "MEMBRESIA")
        .length > 0
    );
  };

  canTokenize = () => {
    /* const { cashboxById } = this.props;
    if (!!cashboxById) {
      return ["ACTIVA"].includes(cashboxById.membresiaSocioEstatus || "");
    }
    return false; */

    const { inteliposChargeResponse: icr } = this.state;
    return !!icr && !!icr.readCard && !!icr.readCard.token;
  };

  shouldForceTokenization = () => {
    const { cashboxById } = this.props;
    if (!!cashboxById) {
      const partnerMembershipStatusForceTokenization = [
        "PENDIENTE",
        "PENDIENTE_REACTIVACION"
      ];

      const tieneCargosMembresia = this.tieneCargosMembresia();
      const tieneEstatusTokenizacionForzosa = partnerMembershipStatusForceTokenization.includes(
        cashboxById.membresiaSocioEstatus || ""
      );

      /*  console.info("Estatus:", cashboxById.membresiaSocioEstatus);
      console.info("Tiene cargos membresia:", tieneCargosMembresia);
      console.info(
        "Tiene estatus tokenizacion forzosa:",
        tieneEstatusTokenizacionForzosa
      );
      console.info(
        "Debe tokenizar:",
        tieneEstatusTokenizacionForzosa && tieneCargosMembresia
      );
 */
      return tieneEstatusTokenizacionForzosa && tieneCargosMembresia;
    }

    return false;
  };

  getMonthWithoutInterestOptions = bank => {
    const total = this.state.newCart
      ? this.state.newCart.total
      : this.props.cashboxById.productos
          .filter(x => x.tipoItem != "MANTENIMIENTO")
          .reduce((acum, { total }) => acum + total, 0.0);

    let options = [...mesesSinInteresesDefault];
    options.push({
      id: 3,
      nombre: "3 Meses sin intereses",
      active: bank.tresMeses <= total && !!bank.estatusTresMeses
    });
    options.push({
      id: 6,
      nombre: "6 Meses sin intereses",
      active: bank.seisMeses <= total && !!bank.estatusSeisMeses
    });
    options.push({
      id: 9,
      nombre: "9 Meses sin intereses",
      active: bank.nueveMeses <= total && !!bank.estatusNueveMeses
    });
    options.push({
      id: 12,
      nombre: "12 Meses sin intereses",
      active: bank.doceMeses <= total && !!bank.estatusDoceMeses
    });
    return options;
  };

  guardarCargo = () => {
    const { products } = this.state;
    let shouldTokenize = this.canTokenize() && this.state.fields.tokenizar;

    //Si no se marco el check de tokenizar, se busca si la caja tiene un item del tipo "Activacion Tokenizacion" y si lo tiene, se marca para tokenizar

    /* if (!shouldTokenize && this.shouldForceTokenization()) {
      shouldTokenize = true;
    }*/

    /* if (!shouldTokenize) {
      shouldTokenize = products
        .map(({ sportsProductId }) => sportsProductId)
        .includes(TOKENIZATION_ACTIVATION_PRODUCT_ID);
    } */

    const { numeroAutorizacion, referencia, readCard } =
      this.state.inteliposChargeResponse || {};

    const data = {
      ...this.state.fields,
      numeroAutorizacion: numeroAutorizacion,
      referencia: referencia,
      itemsIds: products.map(({ itemId }) => itemId),
      tokenizar: shouldTokenize,
      readCard: readCard,
      origenPlataforma: OrigenPlataformaVentaPago.INTELIPOS
    };

    console.info("datos de pago");
    console.info(data);

    if (!data.numeroAutorizacion) {
      return;
    }

    this.setState({ objetoReimpresion: {}, getReference: true });
    this.props
      .payQuote(this.props.personaId, data)
      .then(({ value: { data: { carrito } } }) => {
        this.setState({
          waitingPayment: false,
          inteliposPrechargeData: null,
          inteliposChargeResponse: null,
          applyPaymentModalIsOpen: false
        });

        this.updateProducts(carrito);
      });
    this.props.clearReference();
  };

  debouncedGuardarCargo = debounce(this.guardarCargo, 3000);

  guardarStateDate = (objPrint, openModal) => {
    const { readCard } = this.state;
    readCard.token = objPrint.token;
    this.setState({
      objetoReimpresion: objPrint,
      reimpresionModal: openModal,
      readCard
    });
  };

  guardarDataCard = data => {
    this.setState({ readCard: data });
  };

  handleSubmit = () => {
    if (!this.props.cartCreated) {
      this.setState({ isPending: true });
      this.props
        .saveSPQuote(this.props.newCart)
        .then(async ({ value: { data: { cajaId, error, message } } }) => {
          if (error) {
            errorNotification(message);
          } else {
            if (this.props.productsList.length > 0) {
              await this.props.getCashboxById(cajaId);
              const data = {
                ...this.state.fields,
                monto:
                  this.props.amountPending !== -1
                    ? this.props.amountPending
                    : this.state.fields.monto,
                itemsIds: this.props.cashboxById.productos.map(
                  ({ itemId }) => itemId
                ),
                lineaPago: false
              };
              if (data.formaDePago == LINEA_PAGO) {
                data.formaDePago = ID_EFECTIVO;
                data.lineaPago = true;
              }
              this.props
                .payQuote(cajaId, data)
                .then(({ value: { data: { carrito } } }) => {
                  this.updateProducts(carrito);
                  this.props.history.push(getLinkCaja(cajaId));
                });
            }
          }
        });
    } else {
      if (
        this.state.fields.formaDePago == TARJETA_CREDITO ||
        this.state.fields.formaDePago == TARJETA_DEBITO ||
        this.state.fields.formaDePago == TARJETA_AMEX
      ) {
        //Se ejecuta el proceso de cobro con terminal
        this.mitInteliposProcessStart();
      }
    }
  };

  debouncedHandleSubmit = debounce(this.handleSubmit, 3000);

  ///Funciones para proceso de mit

  mitInteliposProcessStart = () => {
    infoNotification("Iniciando proceso de pago");

    if (!this.state.fields.numeroSerieIntelipos) {
      errorNotification("Debe seleccionar un dispositivo");
    }

    //Se genera el cargo
    const payload = {
      cajaId: this.props.cashboxById.id,
      referencia: this.props.terminal.ReferenceSantander.toString(),
      numeroSerieIntelipos: this.state.fields.numeroSerieIntelipos,
      monto: this.state.fields.monto,
      msi: this.state.mesesSinIntereses
    };

    console.info("Intelipos charge payload");
    console.info(payload);

    this.setState({ waitingPayment: true });

    createInteliposChargeRequest(payload)
      .then(({ data }) => {
        this.setState({
          waitingPayment: true,
          inteliposPrechargeData: { ...data },
          inteliposChargeResponse: null
        });
      })
      .catch(err => {
        this.setState({ waitingPayment: false });
        handleRequestError(err);
      });
  };

  mitInteliposRetrivingChargeResponseProcessStart = () => {
    setInterval(() => {
      const { waitingPayment, inteliposPrechargeData } = this.state;

      if (!!waitingPayment && !!inteliposPrechargeData) {
        console.info("Ejecutando timeout para buscar respuesta");

        getInteliposChargeResponseByReference(inteliposPrechargeData.referencia)
          .then(({ data }) => {
            console.info("Consulta de pago intelipos - Respuesta: ");
            console.info(data);

            if (!!data.mitTrxEstatus) {
              if (data.mitTrxEstatus == "APPROVED") {
                this.setState({
                  waitingPayment: false,
                  inteliposChargeResponse: { ...data },
                  applyPaymentModalIsOpen: true
                });
              } else {
                const { mitTrxFullResponse } = data;
                errorNotification(
                  `Error al completar pago en terminal intelipos. Resultado: ${
                    data.mitTrxEstatus
                  }. Descripción: ${mitTrxFullResponse.TrxDescription ||
                    mitTrxFullResponse.trxDescription}`
                );
                this.setState({
                  waitingPayment: false,
                  inteliposPrechargeData: null,
                  inteliposChargeResponse: null,
                  applyPaymentModalIsOpen: false
                });
              }
            }
          })
          .catch(err => {
            console.error(err);
          });
      }
    }, 8000);
  };

  ///-----------------------------

  onRadioBtnClick(mesesSinIntereses) {
    let products;

    if (!this.props.cartCreated) {
      products = [...this.props.productsList];
    } else {
      const {
        cashboxById: { productos }
      } = this.props;

      products = !isNil(productos) ? productos.map(itemToProduct) : [];
    }

    products = !!mesesSinIntereses
      ? (products || []).filter(x => x.tipoItem != "MANTENIMIENTO")
      : products;

    this.setState({
      ...this.state,
      products,
      fields: {
        ...this.state.fields,
        mesesSinIntereses,
        monto: getSubTotal(products)
      }
    });
  }

  onChangeField = field => {
    return e => {
      const value = e.target.value;
      const { cashboxById } = this.props;
      if (field == "formaDePago" && value == "POR_DEFINIR_99") {
        if (
          !this.state.referenciaOtorgadaPorTesoreria &&
          !this.state.pagoRealizadoPorApp
        ) {
          this.props.getRefenceSantanderComplemento(
            cashboxById.sucursalClubId.toString(),
            this.state.quote.total.toString(),
            value
          );
        }
        this.setState({
          ...this.state,
          fields: {
            ...this.state.fields,
            [field]: value,
            referencia: "",
            monto: this.state.quote.total
          }
        });
      } else if (field == "formaDePago" && value == LINEA_PAGO) {
        const optionsMonthsWithoutInterest = this.getOptionsMonthsWithoutInterestForPaymentLine();
        this.setState({
          mesesSinIntereses: "",
          optionsMonthsWithoutInterest,
          fields: {
            ...this.state.fields,
            [field]: value
          }
        });
      } else {
        if (
          !this.state.referenciaOtorgadaPorTesoreria &&
          !this.state.pagoRealizadoPorApp
        ) {
          if (field == "formaDePago") {
            this.props.getRefenceSantanderCargo(
              cashboxById.sucursalClubId.toString(),
              cashboxById.productos[0].itemId.toString(),
              value
            );
          }
        }
        this.setState({
          ...this.state,
          fields: {
            ...this.state.fields,
            [field]: value
          }
        });
      }
    };
  };

  onChangeAmount = e => {
    if (!this.props.cartCreated) this.props.pendingPayment(e.target.value);
    this.setState({
      fields: {
        ...this.state.fields,
        monto: e.target.value
      }
    });
  };

  disableButtonOption = value => {
    if (value == ID_CONTADO) {
      return false;
    } else if (this.state.fields.formaDePago == LINEA_PAGO) {
      return false;
    } else if (
      this.state.fields.formaDePago != TARJETA_CREDITO &&
      this.state.fields.formaDePago != TARJETA_AMEX
    ) {
      return true;
    } else if (this.state.fields.bancoId) {
      const banco = this.props.banksMonthsWithoutInterest.find(
        ({ bancoId }) => bancoId == this.state.fields.bancoId
      );
      //Regresa el estatus de los meses sin interes de acuerdo al # de meses sin intereses
      return !banco[valueToField(value)];
    }
    return true;
  };

  revision = () => {
    let valReturn = true;

    if (
      this.state.fields &&
      (this.state.fields.formaDePago == "TDC" ||
        this.state.fields.formaDePago == "TDD" ||
        this.state.fields.formaDePago == "AMEX") &&
      this.state.fields.bancoId.length > 0 &&
      parseInt(this.state.fields.bancoId) > 0
    ) {
      valReturn = false;
    }

    return valReturn;
  };

  toggleModalNoSale = () => {
    this.setState({
      showModalNoSale: !this.state.showModalNoSale
    });
  };

  toggleModalDatosFactValidacion = () => {
    this.setState({
      showModalDatosFactValidacion: !this.state.showModalDatosFactValidacion
    });
  };

  disablePayButtonIfForcePaymentMenthod = () => {
    const { products, referenciaOtorgadaPorTesoreria } = this.state;
    const selectedPaymentMethod = this.state.fields.formaDePago || "";

    if (
      !!referenciaOtorgadaPorTesoreria ||
      selectedPaymentMethod == POR_DEFINIR_99
    ) {
      return false;
    }

    const productWithDiscountPaymentMethod = (products || []).find(
      x =>
        !!x.formaPagoParaDescuento &&
        x.formaPagoParaDescuento != FORMA_DE_PAGO.MENSUAL
    );
    if (!!productWithDiscountPaymentMethod) {
      return (
        (productWithDiscountPaymentMethod.formaPagoParaDescuento ==
          FORMA_DE_PAGO.TDC &&
          !(
            selectedPaymentMethod == TARJETA_CREDITO ||
            selectedPaymentMethod == TARJETA_AMEX
          )) ||
        (productWithDiscountPaymentMethod.formaPagoParaDescuento ==
          FORMA_DE_PAGO.TDD &&
          selectedPaymentMethod != TARJETA_DEBITO)
      );
    }
    return false;
  };

  getBankOptions = () => {
    if (this.state.fields.formaDePago === TARJETA_AMEX) {
      return (this.props.banksMonthsWithoutInterest || [])
        .sort((a, b) => a.nombre.localeCompare(b.nombre))
        .filter(x => AMEX_BANK_NAME.includes(x.nombre))
        .map(option => ({
          value: option.bancoId,
          label: option.nombre
        }));
    } else {
      return (this.props.banksMonthsWithoutInterest || [])
        .sort((a, b) => a.nombre.localeCompare(b.nombre))
        .filter(x => !AMEX_BANK_NAME.includes(x.nombre))
        .map(option => ({
          value: option.bancoId,
          label: option.nombre
        }));
    }
  };

  render() {
    const erroresDatosFacturacion =
      this.props.cashboxById != null
        ? (this.props.cashboxById.erroresDatosFacturacion || "")
            .split("\n")
            .filter(x => !!x)
        : [];

    const { products } = this.state;

    return (
      <Container className="w-100 p-0 my-3">
        <ReimpresionModal
          numeroAutorizacion={
            (this.state.inteliposChargeResponse || {}).numeroAutorizacion || ""
          }
          isOpen={this.state.applyPaymentModalIsOpen}
          onOk={async () => {
            infoNotification("Aplicando pago...");
            await this.setState({
              applyingCardPayment: true
            });
            this.debouncedGuardarCargo();
          }}
          showCheck={
            FORMA_PAGO_TOKENIZACION.includes(this.state.fields.formaDePago) &&
            this.canTokenize()
          }
          setTokenizar={() => {
            let { fields } = this.state;
            fields.tokenizar = !this.state.fields.tokenizar;
            this.setState({ fields });
          }}
        />

        <div className="form-row mt-1 mb-1">
          <div className="col">
            <BaseInput
              label="Forma de Pago"
              name="formaDePagoPagoProductos"
              type="select"
              id="formaDePagoPagoProductos"
              placeholder="Forma de Pago"
              options={this.state.permission99.map(option => ({
                value: option,
                label: option == "POR_DEFINIR_99" ? "99 - POR DEFINIR" : option
              }))}
              value={this.state.fields.formaDePago}
              onChange={this.onChangeField("formaDePago")}
            />
          </div>
          <div className="col">
            <BaseInput
              label="Banco"
              name="bancoId"
              type="select"
              id="bancoId"
              placeholder="Banco"
              value={this.state.fields.bancoId}
              size="sm"
              disabled={
                !(
                  this.state.fields.formaDePago === TARJETA_CREDITO ||
                  this.state.fields.formaDePago === TARJETA_DEBITO ||
                  this.state.fields.formaDePago === TARJETA_AMEX
                )
              }
              onChange={this.onChangeBank}
              options={[
                { value: "", label: "Banco" },
                ...this.getBankOptions()
              ]}
            />
          </div>

          <div className="col">
            <BaseInput
              label="Intelipos"
              id="inteliposSelector"
              name="inteliposSelector"
              type="select"
              placeholder="Intelipos"
              options={[
                { value: -1, label: "Seleccione un dispositivo" }
              ].concat(
                (this.state.inteliposDevices || []).map(option => ({
                  value: option.numeroSerie,
                  label: option.nombre
                }))
              )}
              value={this.state.fields.numeroSerieIntelipos}
              onChange={this.onChangeField("numeroSerieIntelipos")}
            />
          </div>
        </div>

        <Row>
          <Col />
          <Col>
            <ButtonGroup>
              {(this.state.optionsMonthsWithoutInterest || []).map(x => (
                <Button
                  className={s.radioButton}
                  color="secondary"
                  onClick={() => this.onRadioBtnClick(x.id)}
                  active={this.state.fields.mesesSinIntereses === x.id}
                  disabled={!x.active || this.disableButtonOption(x.id)}
                >
                  {(x.nombre || "").toLocaleUpperCase()}
                </Button>
              ))}
            </ButtonGroup>
          </Col>
          <Col />
        </Row>

        <Row style={{ minHeight: "300px" }} className="m-0">
          <ProductsList
            products={this.state.products}
            minRows={12}
            loading={this.props.saving || this.props.loading}
            freezeObject={this.state.freezeObject}
            setFreezeObject={this.setFreezeObject}
            applyCheckValidations={true}
          />
        </Row>

        {this.shouldForceTokenization() && (
          <div className="alert alert-warning mt-4 mb-4">
            <TextWithLineBreaks
              text={
                "Se encuentra en un proceso de venta/reactivación de membresía socio.\nSe registrará como medio de pago para cargo automático la tarjeta con la cual se haya hecho el pago con el monto mas alto."
              }
            />
          </div>
        )}

        <div className="form-row mt-1">
          <div className="col">
            <BaseInput
              label="Referencia"
              name="referenciaPagoProductos"
              type="text"
              id="referenciaPagoProductos"
              placeholder="Referencia"
              value={
                this.props.terminal.ReferenceSantander.toString().length > 0
                  ? this.props.terminal.ReferenceSantander.toString()
                  : this.state.fields.referencia
              }
              onChange={this.onChangeField("referencia")}
              disabled={
                this.state.fields.formaDePago == "POR_DEFINIR_99" ||
                this.props.terminal.ReferenceSantander.toString().length > 0
              }
            />
          </div>

          <div className="col">
            <BaseInput
              label="Nro Autorización"
              name="nroAutorizacionPagoProductos"
              type="text"
              id="nroAutorizacionPagoProductos"
              placeholder="Nro Autorizacion"
              value={this.state.fields.numeroAutorizacion}
              onChange={this.onChangeField("numeroAutorizacion")}
              disabled={true}
            />
          </div>

          <div className="col">
            <BaseInput
              label="Monto a Pagar"
              name="montoPagoProductos"
              type="number"
              id="montoPagoProductos"
              placeholder="Nro Autorizacion"
              value={this.state.fields.monto}
              disabled={
                this.state.fields.formaDePago == "POR_DEFINIR_99" ||
                this.state.fields.formaDePago == LINEA_PAGO
              }
              onChange={this.onChangeAmount}
            />
          </div>
        </div>
        <hr />
        <Row className="my-1">
          <Col>
            <PaymentsTable payments={this.state.pagos}></PaymentsTable>
          </Col>
        </Row>
        <Row className="m-0">
          <Col></Col>
          <Col xs={2} className="float-right pr-0 pt-2 m-0">
            {!!this.state.quote &&
              this.state.quote.estatus == QUOTE_CREATED_STATUS &&
              erroresDatosFacturacion.length == 0 && (
                <Button
                  className={`${s.buttonMarginTop} ${s.primaryButton} float-right`}
                  onClick={async e => {
                    if (!!e) e.preventDefault();

                    infoNotification("Aplicando pago...");
                    this.debouncedHandleSubmit();
                  }}
                  size="sm"
                  block
                  disabled={
                    this.state.waitingPayment ||
                    !this.state.fields.numeroSerieIntelipos ||
                    this.props.saving ||
                    this.props.loading ||
                    this.disablePayButtonIfForcePaymentMenthod() ||
                    this.revision() ||
                    this.state.applyingMainPayment
                  }
                >
                  Generar Pago
                </Button>
              )}
            {((!!this.state.quote &&
              this.state.quote.estatus != QUOTE_CREATED_STATUS) ||
              erroresDatosFacturacion.length > 0) && (
              <Button
                className={`${s.buttonMarginTop} ${s.primaryButton} float-right`}
                onClick={() => {
                  this.props.history.push("/inicio");
                }}
                size="sm"
                block
              >
                Regresar
              </Button>
            )}
          </Col>

          {/* <Col xs={2} className="float-right pr-0 pt-2 m-0">

            <Button
              className={`${s.buttonMarginTop} ${s.primaryButton} float-right`}
              onClick={e => {

                getInteliposChargeResponseByReference("000033723316189")
                  .then(({ data }) => {
                    console.info("Consulta de pago intelipos - Respuesta: ");
                    console.info(data);

                    if (!!data.mitTrxEstatus) {
                      if (data.mitTrxEstatus == "APPROVED") {
                        this.setState({
                          waitingPayment: false,
                          inteliposChargeResponse: { ...data },
                          applyPaymentModalIsOpen: true
                        });
                      } else {
                        const { mitTrxFullResponse } = data;
                        errorNotification(
                          `Error al completar pago en terminal intelipos. Resultado: ${data.mitTrxEstatus
                          }. Descripción: ${mitTrxFullResponse.TrxDescription ||
                          mitTrxFullResponse.trxDescription}`
                        );
                        this.setState({
                          waitingPayment: false,
                          inteliposPrechargeData: null,
                          inteliposChargeResponse: null,
                          applyPaymentModalIsOpen: false
                        });
                      }
                    }
                  })
                  .catch(err => {
                    console.error(err);
                  });

              }}
              size="sm"
              block
            >
              Consultar referencia
            </Button>


          </Col> */}
        </Row>

        <Modal
          isOpen={this.state.showModalNoSale}
          toggle={this.toggleModalNoSale}
          fade={true}
          size="lg"
          backdrop="static"
          keyboard={false}
        >
          <ModalBody>
            <h4 className="text-danger">Caja</h4>
            <h5>
              No es posible continuar con la venta. <br />
              El usuario no tiene un club asignado en su sesión.
            </h5>
          </ModalBody>
          <ModalFooter>
            <Button
              className={`${s.secondaryButton} d-inline-block mr-2`}
              onClick={() => {
                this.props.history.push("/inicio");
              }}
            >
              SALIR
            </Button>
          </ModalFooter>
        </Modal>

        {/*Modal para mostrar loading mientras se realiza el pago en caja*/}
        <Modal
          isOpen={this.state.waitingPayment}
          toggle={() => {}}
          fade={true}
          size="md"
          backdrop="static"
          keyboard={false}
        >
          <ModalBody>
            <BasicSpinner
              message={"Continuar con el pago en el dispositivo"}
              loading={this.state.waitingPayment}
            />
          </ModalBody>
        </Modal>

        {!!erroresDatosFacturacion.length && (
          <Modal
            isOpen={this.state.showModalDatosFactValidacion}
            toggle={this.toggleModalDatosFactValidacion}
            fade={true}
            size="lg"
            backdrop="static"
            keyboard={false}
          >
            <ModalBody>
              <h4 className="text-danger">
                Validación datos de facturación del cliente
              </h4>
              <div>
                <ul>
                  {erroresDatosFacturacion
                    .filter(x => !!x)
                    .map(x => {
                      return <li>{x}</li>;
                    })}
                </ul>
              </div>
            </ModalBody>
            <ModalFooter>
              <Button
                className={`${s.secondaryButton} d-inline-block mr-2`}
                onClick={() => {
                  this.setState({
                    acceptedModalDatosFactValidacion: true,
                    showModalDatosFactValidacion: false
                  });
                }}
              >
                ACEPTAR
              </Button>
            </ModalFooter>
          </Modal>
        )}
      </Container>
    );
  }
}
export default withRouter(withStyles(s)(SportsProductsQuoteInteliposById));
